<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/OfTheYear/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>